import { Component, Input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgClass } from '@angular/common';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { ScIconPipe } from '@core/jss-utils';

import {
  BasicContentHeading,
  BasicContentIcon,
  HeaderSize,
} from '../../basic-content-settings.model';

@Component({
  selector: 'wl-basic-content-partial-heading',
  templateUrl: './basic-content-partial-heading.component.html',
  styleUrls: ['./basic-content-partial-heading.component.ed.scss'],
  standalone: true,
  imports: [FaIconComponent, NgClass, JssModule, ScIconPipe],
})
export class BasicContentPartialHeadingComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() heading?: BasicContentHeading;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() icon?: BasicContentIcon;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() centerText?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() size: HeaderSize = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showIcon = true;
}
